<template>
  <v-app-bar fixed class="pa-1">
    <v-container fluid class="pa-0">
      <v-row no-gutters class="d-flex align-center justify-space-between">
        <v-col cols="7">
          <v-img
            class="ma-0 pa-0 text-start"
            width="200"
            src="@/assets/Kotler_and_levit_logo.png"
          />
        </v-col>
        <v-col cols="5">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="paymentDialog = true"
              size="small"
              variant="tonal"
              color="primary"
              >Payments</v-btn
            >
            <v-btn
              v-if="VuetifyObj.mdAndUp"
              class="mx-2"
              size="small"
              variant="tonal"
              color="primary"
              @click="routeTo"
            >
              Enroll Now
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
  <v-app class="mt-2">
    <PaymentsDialog
      :payment_details="payment_details"
      :VuetifyObj="VuetifyObj"
      :paymentDialog="paymentDialog"
      @clicked="paymentDialogEmit"
    />
    <!-- App Bar / Header with Logo -->

    <!-- Hero Section -->
    <v-main>
      <section class="hero-section">
        <v-container fluid class="pa-0">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="hero-overlay">
                <v-container class="text-center py-16">
                  <v-row justify="center">
                    <v-col cols="12" md="10" lg="8">
                      <h1
                        class="text-h3 text-h2-md-up font-weight-bold mb-6 white--text"
                      >
                        Kotler & Levitt Skills Institute
                      </h1>
                      <p class="text-h6 mb-8 white--text opacity-90">
                        World-Class Training for Customs Brokers and Logistics
                        Professionals
                      </p>
                      <v-btn
                        size="large"
                        color="white"
                        class="text-primary font-weight-bold px-8 py-4"
                        @click="routeTo"
                      >
                        Start Your Journey
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Main Content Section -->
      <section class="content-section">
        <v-container class="py-12">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <div class="text-center mb-12">
                <h2 class="text-h4 font-weight-bold primary--text mb-4">
                  Your Gateway to Excellence in Logistics & Customs
                </h2>
                <v-divider
                  class="mx-auto"
                  style="width: 100px; border-color: #1976d2"
                ></v-divider>
              </div>
              <v-card
                flat
                class="pa-8 rounded-lg elevation-0"
                color="transparent"
              >
                <p
                  class="text-body-1 text-left mb-6"
                  v-html="instituteDescription"
                ></p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Features Teaser Section (Optional: Highlights key areas) -->
      <section class="features-section">
        <v-container class="py-12">
          <v-row justify="center">
            <v-col cols="12" md="10">
              <h3
                class="text-h5 font-weight-bold text-center mb-8 primary--text"
              >
                What We Offer
              </h3>
              <v-row class="d-flex justify-center">
                <v-col
                  v-for="(feature, i) in features"
                  :key="i"
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-card
                    class="pa-6 text-center rounded-xl elevation-4 hover-elevation"
                    color="white"
                    height="100%"
                  >
                    <v-icon :color="feature.color" size="48" class="mb-4">
                      {{ feature.icon }}
                    </v-icon>
                    <h4 class="text-h6 font-weight-bold mb-2">
                      {{ feature.title }}
                    </h4>
                    <p class="text-body-2 text-medium-emphasis">
                      {{ feature.desc }}
                    </p>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- CTA Section -->
      <section class="cta-section">
        <v-container class="py-12 text-center">
          <v-row justify="center">
            <v-col cols="12" md="8">
              <h2 class="text-h4 font-weight-bold white--text mb-4">
                Ready to Transform Your Career?
              </h2>
              <p class="text-h6 white--text mb-6 opacity-90">
                Join thousands of professionals who've advanced with us.
              </p>
              <v-btn
                size="large"
                color="primary"
                class="px-8 py-4 font-weight-bold"
                @click="routeTo"
              >
                Get Started Today
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Footer -->
      <v-footer color="primary" class="text-center white--text py-2">
        <v-container>
          <div class="text-center text-h6">Contact Us</div>
          <v-row class="text-white text-center" justify="center">
            <!-- Contact Details Section -->
            <v-col cols="12" class="mb-2">
              <div
                class="d-flex flex-column flex-md-row align-center justify-center"
              >
                <!-- Phone -->
                <div class="d-flex align-center mx-md-4 mb-2 mb-md-0">
                  <v-icon size="20" class="me-2">mdi-phone</v-icon>
                  <span class="footer-text">+91 98402 98504</span>
                </div>

                <!-- Separator (shown only on desktop) -->
                <div
                  class="d-none d-md-flex mx-2"
                  style="
                    height: 20px;
                    width: 1px;
                    background: rgba(255, 255, 255, 0.4);
                  "
                ></div>

                <!-- Email -->
                <div class="d-flex align-center mx-4">
                  <v-icon size="20" class="me-2">mdi-email-outline</v-icon>
                  <span class="footer-text text-email"> kotelrlevitt.skillsinstitute@gmail.com</span>
                </div>
              </div>
            </v-col>

            <!-- Copyright -->
            <v-col cols="12">
              <p class="footer-copy mb-0">
                &copy; 2025 Kotler & Levitt Skills Institute
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import { useDisplay } from "vuetify";
import axios from "axios";
import PaymentsDialog from "@/components/PaymentsDialog.vue";
export default {
  name: "LandingPage",
  components: {
    PaymentsDialog,
  },
  data() {
    return {
      paymentDialog: false,
      VuetifyObj: {},
      payment_details: {},
      instituteDescription: `
        <p>Kotler & Levitt Skills Institute is committed to empowering the next generation of logistics professionals and customs brokers through world-class training, practical learning, and continuous skill development. We help aspiring candidates and working professionals build deep expertise, enhance operational excellence, and stay competitive in a rapidly evolving global trade environment.</p>
        <p>Our specialized training modules, real-life case studies, and comprehensive mock tests strengthen knowledge across logistics, freight forwarding, port operations, air cargo handling, supply chain essentials, and customs compliance. Whether you are preparing for competitive examinations such as the CBLR (Customs Brokers Licensing Regulations) or aiming to advance your professional capabilities, Kotler & Levitt Skills Institute provides the right foundation for a successful career in logistics and customs brokerage.</p>
      `,
      features: [
        // {
        //   icon: "mdi-truck",
        //   title: "Logistics Mastery",
        //   desc: "Comprehensive modules on freight forwarding and supply chain.",
        //   color: "primary",
        // },
        // {
        //   icon: "mdi-airplane",
        //   title: "Air Cargo Expertise",
        //   desc: "Hands-on training for port and air operations.",
        //   color: "info",
        // },
        {
          icon: "mdi-shield-check",
          title: "Customs Compliance",
          desc: "Prepare for CBLR with mock tests and case studies.",
          color: "success",
        },
      ],
    };
  },
  async mounted() {
    this.VuetifyObj = useDisplay();
    try {
      let data = {
        command: "getQuizzDetails",
      };
      let config = {
        method: "post",
        url: "https://hwfdmjv1vj.execute-api.ap-south-1.amazonaws.com/production/get_quizz_details",
        data: data,
      };
      let result = await axios(config);
      if (result.data.status === "SUCCESS") {
        let res = result.data.data.items.payment_details;
        if (res) {
          this.payment_details = res;
          console.log("Res: ", this.payment_details);
          if (this.payment_details.qr_code_url) {
            // this.paymentDialog.qr_code_url =
            //   await this.GetBase64MethodFromPreSignedURLMethod(
            //     this.paymentDialog.qr_code_url
            //   );
          }
        }
      }
    } catch (error) {
      console.log("error : ", error);
      this.SnackbarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "error",
        SnackbarText: error,
      };
    }
  },
  methods: {
    // async GetBase64MethodFromPreSignedURLMethod(PreSignedURL) {
    //   try {
    //     const result = await axios({
    //       method: "get",
    //       url: PreSignedURL,
    //       responseType: "arraybuffer", // required for base64
    //     });

    //     if (result.status === 200) {
    //       // Convert to base64
    //       const base64String = btoa(
    //         new Uint8Array(result.data).reduce(
    //           (data, byte) => data + String.fromCharCode(byte),
    //           ""
    //         )
    //       );

    //       return base64String;
    //     }
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
    // async GetBase64MethodFromPreSignedURLMethod(PreSignedURL) {
    //   try {
    //     let config = {
    //       method: "get",
    //       maxBodyLength: Infinity,
    //       url: PreSignedURL,
    //       responseType: "arraybuffer", // required for base64
    //     };
    //     let result = await axios(config);
    //     if (result.status === 200 && result.statusText === "OK") {
    //       return result.data;
    //     }
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
    routeTo() {
      this.$router.push("/home");
    },
    scrollToContact() {
      // Implement contact or enrollment logic, e.g., open modal or navigate
      window.alert("Redirecting to enrollment..."); // Placeholder
    },
    paymentDialogEmit() {
      this.paymentDialog = false;
    },
  },
};
</script>

<style scoped>
.hero-section {
  background: linear-gradient(90deg, #103e90, #30b8b8) !important;
  min-height: 60vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.hero-overlay {
  background: rgba(0, 0, 0, 0.3);
  min-height: 100%;
  display: flex;
  align-items: center;
}

.content-section {
  background-color: #f8f9fa;
}

.features-section {
  background-color: white;
}

.cta-section {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
}

.hover-elevation {
  transition: all 0.3s ease;
}

.hover-elevation:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

@media (max-width: 960px) {
  .hero-section {
    min-height: 50vh;
  }

  .py-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

/* Responsive text sizing */
.text-h2-md-up {
  font-size: 3.5rem !important;
  line-height: 1.2;
}

@media (max-width: 960px) {
  .text-h2-md-up {
    font-size: 2.5rem !important;
  }
}
</style>
